export function isOneOf(v: any, values: any[]): boolean {
  return values.indexOf(v) > -1;
}
